import type { SegmentedProps as AntdSegmentedProps } from "antd";
import { Segmented as AntdSegmented } from "antd";
import React, { forwardRef } from "react";
import * as styles from "./Segmented.css";

export interface SegmentedProps extends AntdSegmentedProps {}
const Segmented = forwardRef<HTMLDivElement, SegmentedProps>(
  ({ className, ...props }, ref) => {
    // Need to use css to override background color of Segmented because
    // 'trackBg' design token is not available in antd v5.12
    const composedClassName = [styles.baseSegmented, className]
      .filter(Boolean)
      .join(" ");

    return <AntdSegmented {...props} className={composedClassName} ref={ref} />;
  }
);

export default Segmented;
